<template>
  <div class="chat-wrap">
    <div class="list-wrap">
      <im-list-message />
    </div>
    <div class="textarea-wrap">
      <im-textarea :content="content" />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'imChat',
  props: {
    to: {
      type: [String, null],
      default: ''
    },
    conversationId: {
      type: String,
      default: ''
    },
    content: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  watch: {
    to(n, o) {
      if (n !== o) {
        this.SET_IM_TO(n)
      }
    },
    conversationId(n, o) {
      if (n !== o) {
        this.setConversationId(n) // 进入页面设置会话id
      }
    }
  },
  methods: {
    ...mapMutations('IM/message', ['setConversationId']),
    ...mapMutations('IM', ['SET_IM_TO'])
  }
}
</script>

<style lang="scss" scoped>
.chat-wrap {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .list-wrap {
    flex: 1;
    overflow: hidden;
  }
  .textarea-wrap {
    width: 100%;
  }
}
</style>
